<template>
    <ul
        class="context-menu">
      <li @click="selectOption('Öffnen')">{{ $t('ContextMenu.Open') }}</li>
      <li @click="selectOption('Umbenennen')">{{ $t('ContextMenu.Rename') }}</li>
      <li @click="selectOption('Löschen')">{{ $t('ContextMenu.Delete') }}</li>
    </ul>
  </template>
  
  <script>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  export default {
    props: {
      contextItem: Object // 🔥 Das Item, für das das Menü geöffnet wurde
    },
    emits: ["delete", 'openItem', 'close', 'renameItem'],
    setup(props, { emit }) {

  
      const selectOption = (option) => {
         if(option == 'Löschen') emit('delete'); 
         if(option == 'Öffnen') emit('openItem');
         if(option == 'Umbenennen') emit('renameItem');
      };
      onMounted(() => {
        document.addEventListener('click', closeContextMenu);
        console.log('mounted')
      });
  
      onUnmounted(() => {
        document.removeEventListener('click', closeContextMenu);
      }); 

      const closeContextMenu = () => {
        emit('close')
      }
  
      return {selectOption };
    }
  };
  </script>
  
  <style scoped>
  .context-menu {
    position: absolute;
    text-align:left;
    background: white;
    border: 1px solid #ccc;
    color: black;
    padding: 5px;
    list-style: none;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    font-size: 14px;
    z-index: 1000;
  }
  
  .context-menu li {
    padding: 5px 10px;
    cursor: pointer;
  }
  
  .context-menu li:hover {
    background: #ddd;
  }
  </style>
  